module.exports = __webpack_public_path__ + "static/media/SopravalCajasAlcaldesa.0115970f.mp3";